/* Kidlio theme behaviour. No dependencies; everything degrades to plain HTML. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Mobile menu ---------------------------------------------------------- */
  const toggle = document.querySelector('[data-kd-menu-toggle]');
  const menu = document.querySelector('[data-kd-mobile-menu]');
  if (toggle && menu) {
    const label = toggle.querySelector('[data-kd-menu-label]');
    const setOpen = (open, { focusToggle = false } = {}) => {
      toggle.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      document.documentElement.classList.toggle('kd-menu-open', open);
      if (label) label.textContent = open ? label.dataset.close : label.dataset.open;
      if (open) {
        const first = menu.querySelector('a, button');
        if (first) first.focus();
      } else if (focusToggle) {
        toggle.focus();
      }
    };
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) setOpen(false, { focusToggle: true });
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches) setOpen(false);
    });
  }

  /* Header elevation on scroll ------------------------------------------ */
  const header = document.querySelector('[data-kd-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Launch-list form validation ----------------------------------------- */
  // The form still posts natively to Shopify; this only adds friendly,
  // screen-reader-announced validation before the request is sent.
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  document.querySelectorAll('form.kd-signup').forEach((form) => {
    const email = form.querySelector('input[type="email"]');
    const consent = form.querySelector('.kd-consent__box');
    if (!email) return;
    form.setAttribute('novalidate', '');

    const showError = (input, key, invalid) => {
      const msg = form.querySelector(`[data-kd-error-for="${key}"]`);
      input.setAttribute('aria-invalid', String(invalid));
      if (!msg) return;
      msg.hidden = !invalid;
      msg.textContent = invalid ? msg.dataset.msg : '';
    };

    email.addEventListener('input', () => {
      if (email.getAttribute('aria-invalid') === 'true' && EMAIL.test(email.value.trim())) showError(email, 'email', false);
    });
    if (consent) consent.addEventListener('change', () => consent.checked && showError(consent, 'consent', false));

    form.addEventListener('submit', (event) => {
      const emailOk = EMAIL.test(email.value.trim());
      const consentOk = !consent || consent.checked;
      showError(email, 'email', !emailOk);
      if (consent) showError(consent, 'consent', !consentOk);
      if (!emailOk || !consentOk) {
        event.preventDefault();
        (!emailOk ? email : consent).focus();
        return;
      }
      // Shopify's spam check (hCaptcha) may hold the submission or show a
      // challenge the visitor can close, so never leave the button stuck.
      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.classList.add('is-loading');
        window.setTimeout(() => {
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading');
        }, 6000);
      }
    });
  });

  /* Bring server-side form results into view and focus ------------------- */
  const status = document.querySelector('[data-kd-focus-on-load]');
  if (status) {
    status.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    status.focus({ preventScroll: true });
  }

  /* Dialogs (store-owner password) -------------------------------------- */
  document.querySelectorAll('[data-kd-dialog-open]').forEach((button) => {
    const dialog = document.getElementById(button.dataset.kdDialogOpen);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    button.addEventListener('click', () => dialog.showModal());
  });
  document.querySelectorAll('[data-kd-dialog-close]').forEach((button) => {
    button.addEventListener('click', () => button.closest('dialog').close());
  });
  document.querySelectorAll('[data-kd-open-dialog]').forEach((el) => {
    const dialog = document.getElementById(el.dataset.kdOpenDialog);
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  });


  /* Privacy & other policy pages: reading layout + table of contents --------- */
  // Shopify renders policies itself; this only reorganises the page for reading.
  // The legal text is never changed.
  const policy = document.querySelector('.shopify-policy__container');
  const policyBody = policy && policy.querySelector('.shopify-policy__body');
  if (policyBody) {
    const heads = [...policyBody.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim());
    if (heads.length >= 3) {
      const slug = (t, i) => 'policy-' + (t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || i);
      const layout = document.createElement('div');
      layout.className = 'kd-policy-layout';
      const nav = document.createElement('nav');
      nav.className = 'kd-policy-toc';
      nav.setAttribute('aria-label', 'On this page');
      const details = document.createElement('details');
      if (window.matchMedia('(min-width: 990px)').matches) details.open = true;
      details.innerHTML = '<summary>On this page <svg class="kd-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="m6 9 6 6 6-6"/></svg></summary>';
      const list = document.createElement('ol');
      heads.filter((h) => h.tagName === 'H2').forEach((h, i) => {
        if (!h.id) h.id = slug(h.textContent, i);
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });
      details.appendChild(list);
      nav.appendChild(details);
      policyBody.parentNode.insertBefore(layout, policyBody);
      layout.appendChild(nav);
      layout.appendChild(policyBody);
      window.matchMedia('(min-width: 990px)').addEventListener('change', (e) => { details.open = e.matches; });
      if ('IntersectionObserver' in window) {
        const links = [...list.querySelectorAll('a')];
        const spy = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((l) => l.classList.toggle('is-current', l.getAttribute('href') === '#' + entry.target.id));
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        heads.forEach((h) => h.id && spy.observe(h));
      }
    }
  }

  /* Reveals: only for content that is below the fold when the page loads ------
     Anything the visitor can already see stays visible. Reveals start 15% before
     an element reaches the viewport, so fast scrolling never shows blank screens. */
  const canAnimate = !reduceMotion && 'IntersectionObserver' in window;
  const finePointer = window.matchMedia('(pointer: fine)').matches;
  document.querySelectorAll('.kd-shelf__track, .kd-collection__grid, .kd-pillars__list, .kd-steps, .kd-levels__list').forEach((list) => {
    list.querySelectorAll('.kd-reveal').forEach((el, i) => el.style.setProperty('--kd-i', String(Math.min(i, 4))));
  });
  if (canAnimate) {
    const fold = window.innerHeight * 0.96;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 15% 0px' });
    document.querySelectorAll('.kd-reveal').forEach((el) => {
      if (el.getBoundingClientRect().top < fold) return;
      el.classList.add('kd-will-reveal');
      io.observe(el);
    });
  }

  /* Lio arrives once when his section does ------------------------------------ */
  const lios = document.querySelectorAll('[data-kd-anim]');
  document.documentElement.classList.add('kd-motion');
  if (!canAnimate) {
    lios.forEach((el) => el.classList.add('is-in'));
  } else {
    const lioIo = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        lioIo.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    lios.forEach((el) => lioIo.observe(el));
  }

  /* Pointer depth (mouse/trackpad only) --------------------------------------
     The hero stage's paper layers shift by their own depth; workbench tiles tilt
     a few degrees. CSS eases the movement; rAF only batches pointer events. */
  const follow = (area, target, onMove, onLeave) => {
    let frame = 0;
    let last = null;
    area.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse') return;
      last = event;
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; onMove(target.getBoundingClientRect(), last); });
    });
    area.addEventListener('pointerleave', onLeave);
  };
  const clamp = (v) => Math.max(-1, Math.min(1, v));
  if (canAnimate && finePointer) {
    document.querySelectorAll('[data-kd-stage]').forEach((stage) => {
      const area = stage.closest('section') || stage;
      follow(area, stage, (r, e) => {
        stage.style.setProperty('--kd-px', clamp((e.clientX - (r.left + r.width / 2)) / r.width).toFixed(3));
        stage.style.setProperty('--kd-py', clamp((e.clientY - (r.top + r.height / 2)) / r.height).toFixed(3));
      }, () => { stage.style.setProperty('--kd-px', '0'); stage.style.setProperty('--kd-py', '0'); });
    });
    document.querySelectorAll('[data-kd-tilt]').forEach((tile) => {
      follow(tile, tile, (r, e) => {
        tile.style.setProperty('--kd-tx', clamp(((e.clientX - r.left) / r.width) * 2 - 1).toFixed(3));
        tile.style.setProperty('--kd-ty', clamp(((e.clientY - r.top) / r.height) * 2 - 1).toFixed(3));
      }, () => { tile.style.setProperty('--kd-tx', '0'); tile.style.setProperty('--kd-ty', '0'); });
    });
  }

  /* Try a mission ------------------------------------------------------------
     A level selector (ARIA tabs) and two small games. Nothing is stored or sent. */
  const EASE_IO = 'cubic-bezier(0.65, 0, 0.35, 1)';
  const flyFrom = (el, from) => {
    if (reduceMotion || !el.animate) return;
    const to = el.getBoundingClientRect();
    const dx = from.left + from.width / 2 - (to.left + to.width / 2);
    const dy = from.top + from.height / 2 - (to.top + to.height / 2);
    const s = from.width / Math.max(to.width, 1);
    el.animate([{ transform: `translate(${dx}px, ${dy}px) scale(${s})` }, { transform: 'none' }], { duration: 560, easing: EASE_IO });
  };
  const pulse = (el, cls, ms = 450) => {
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    window.setTimeout(() => el.classList.remove(cls), ms);
  };
  const speak = (panel, text) => {
    const say = panel.querySelector('[data-kd-say]');
    if (!say || say.textContent === text) return;
    if (reduceMotion) { say.textContent = text; return; }
    say.classList.add('is-swapping');
    window.setTimeout(() => { say.textContent = text; say.classList.remove('is-swapping'); }, 220);
  };

  function sortGame(panel, report) {
    const story = panel.querySelector('[data-kd-say]').textContent;
    const hint = panel.querySelector('[data-kd-hint]');
    const done = panel.querySelector('[data-kd-done]');
    const lio = panel.querySelector('.kd-mission__lio');
    const buttons = [...panel.querySelectorAll('.kd-sortbtn')];
    const jars = [...panel.querySelectorAll('.kd-jar')];
    let selected = null;
    let placed = 0;
    let suppressClick = false;

    const setHint = (text, nudge = false) => { hint.textContent = text; hint.classList.toggle('is-nudge', nudge); };
    const colourName = (el) => el.querySelector('.kd-visually-hidden').textContent.replace(/ button$/, '');
    const updateJar = (jar) => {
      const n = jar.querySelectorAll('.kd-jar__slots > *').length;
      jar.querySelector('[data-kd-jar-label]').textContent = `${jar.dataset.name} jar, ${n === 0 ? 'empty' : `${n} button${n > 1 ? 's' : ''}`}`;
    };
    const select = (button) => {
      if (selected) selected.setAttribute('aria-pressed', 'false');
      selected = button === selected ? null : button;
      if (selected) {
        selected.setAttribute('aria-pressed', 'true');
        report(2);
        setHint(`${colourName(selected)} button picked. Now tap the jar it belongs in.`);
      } else {
        setHint(hint.dataset.default);
      }
    };
    const tryJar = (button, jar) => {
      if (button.dataset.color !== jar.dataset.color) {
        pulse(jar, 'is-wrong');
        setHint(`Hmm, that's the ${jar.dataset.name.toLowerCase()} jar. Which jar matches?`, true);
        return false;
      }
      const from = button.getBoundingClientRect();
      const token = document.createElement('span');
      token.className = 'kd-sortbtn is-placed';
      token.setAttribute('style', button.getAttribute('style'));
      token.innerHTML = button.querySelector('svg').outerHTML;
      jar.querySelector('.kd-jar__slots').appendChild(token);
      flyFrom(token, from);
      button.setAttribute('aria-pressed', 'false');
      button.classList.add('is-gone');
      button.disabled = true;
      button.setAttribute('aria-hidden', 'true');
      if (selected === button) selected = null;
      placed += 1;
      updateJar(jar);
      pulse(jar, 'is-right');
      pulse(lio, 'is-nodding', 500);
      if (placed === buttons.length) {
        panel.classList.add('is-complete');
        speak(panel, panel.querySelector('[data-kd-say]').dataset.done);
        setHint(`All ${buttons.length} buttons sorted. Mission complete!`);
        done.hidden = false;
        report(3);
      } else {
        setHint(`Yes! That's the ${jar.dataset.name.toLowerCase()} jar. ${buttons.length - placed} to go.`);
      }
      return true;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (suppressClick) { suppressClick = false; return; }
        select(button);
      });
      // Drag: follows the pointer; drop over a jar to sort, anywhere else to put it back.
      let start = null;
      let dragging = false;
      const jarAt = (x, y) => jars.find((jar) => {
        const r = jar.getBoundingClientRect();
        return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
      });
      button.addEventListener('pointerdown', (event) => {
        if (button.disabled || event.button !== 0) return;
        start = { x: event.clientX, y: event.clientY };
        dragging = false;
        button.setPointerCapture(event.pointerId);
      });
      button.addEventListener('pointermove', (event) => {
        if (!start) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (!dragging && Math.hypot(dx, dy) < 6) return;
        if (!dragging) { dragging = true; button.classList.add('is-dragging'); report(2); }
        button.style.translate = `${dx}px ${dy}px`;
        jars.forEach((jar) => jar.classList.toggle('is-target', jar === jarAt(event.clientX, event.clientY)));
      });
      const end = (event) => {
        if (!start) return;
        const wasDragging = dragging;
        start = null;
        dragging = false;
        jars.forEach((jar) => jar.classList.remove('is-target'));
        if (!wasDragging) return;
        suppressClick = true;
        window.setTimeout(() => { suppressClick = false; }, 0);
        button.classList.remove('is-dragging');
        const jar = event.type === 'pointerup' ? jarAt(event.clientX, event.clientY) : null;
        const sorted = jar ? tryJar(button, jar) : false;
        if (!sorted && !reduceMotion && button.animate) {
          const [x, y] = (button.style.translate || '0px 0px').split(' ');
          button.animate([{ translate: `${x} ${y || '0px'}` }, { translate: '0px 0px' }], { duration: 420, easing: EASE_IO });
        }
        button.style.translate = '';
      };
      button.addEventListener('pointerup', end);
      button.addEventListener('pointercancel', end);
    });

    jars.forEach((jar) => jar.addEventListener('click', () => {
      if (selected) { tryJar(selected, jar); return; }
      setHint('Pick a button first, then its jar.', true);
    }));

    panel.querySelector('[data-kd-replay]').addEventListener('click', () => {
      panel.querySelectorAll('.kd-jar__slots').forEach((slots) => { slots.innerHTML = ''; });
      jars.forEach(updateJar);
      buttons.forEach((button) => {
        button.classList.remove('is-gone');
        button.disabled = false;
        button.removeAttribute('aria-hidden');
        button.setAttribute('aria-pressed', 'false');
      });
      selected = null;
      placed = 0;
      panel.classList.remove('is-complete');
      done.hidden = true;
      speak(panel, story);
      setHint(hint.dataset.default);
      report(1);
      buttons[0].focus();
    });
  }

  function garlandGame(panel, report) {
    const NAMES = { marigold: 'Marigold', leaf: 'Mango leaf', rani: 'Pink flower' };
    const ROUNDS = [
      { seq: ['marigold', 'leaf', 'marigold', 'leaf'], answer: 'marigold' },
      { seq: ['rani', 'rani', 'leaf', 'rani', 'rani'], answer: 'leaf' },
      { seq: ['leaf', 'marigold', 'rani', 'leaf', 'marigold'], answer: 'rani' },
    ];
    const FREE_MAX = 8;
    const story = panel.querySelector('[data-kd-say]').textContent;
    const string = panel.querySelector('[data-kd-string]');
    const roundLabel = panel.querySelector('[data-kd-round]');
    const hint = panel.querySelector('[data-kd-hint]');
    const done = panel.querySelector('[data-kd-done]');
    const lio = panel.querySelector('.kd-mission__lio');
    const art = (name) => panel.querySelector(`template[data-kd-item="${name}"]`).content.cloneNode(true);
    let round = 0;
    let free = false;
    let busy = false;

    const setHint = (text, nudge = false) => { hint.textContent = text; hint.classList.toggle('is-nudge', nudge); };
    const item = (name, isNew) => {
      const li = document.createElement('li');
      li.className = `kd-garland__item${isNew ? ' is-new' : ''}`;
      li.appendChild(art(name));
      const label = document.createElement('span');
      label.className = 'kd-visually-hidden';
      label.textContent = NAMES[name];
      li.appendChild(label);
      return li;
    };
    const gap = () => {
      const li = document.createElement('li');
      li.className = 'kd-garland__item kd-garland__gap';
      li.innerHTML = '<span aria-hidden="true">?</span><span class="kd-visually-hidden">What comes next?</span>';
      return li;
    };
    const render = () => {
      string.innerHTML = '';
      if (free) {
        roundLabel.textContent = 'Your own garland';
        string.appendChild(gap());
        return;
      }
      roundLabel.textContent = `Pattern ${round + 1} of ${ROUNDS.length}`;
      ROUNDS[round].seq.forEach((name) => string.appendChild(item(name)));
      string.appendChild(gap());
    };
    const choose = (name, button) => {
      if (busy) return;
      report(2);
      if (free) {
        const count = string.querySelectorAll('.kd-garland__item:not(.kd-garland__gap)').length;
        const g = string.querySelector('.kd-garland__gap');
        string.insertBefore(item(name, true), g);
        if (count + 1 >= FREE_MAX && g) g.remove();
        setHint(count + 1 >= FREE_MAX ? 'Your garland is full. Lovely!' : `${NAMES[name]} added.`);
        return;
      }
      const target = ROUNDS[round];
      if (name !== target.answer) {
        pulse(button, 'is-wrong');
        setHint('Not quite. Look at what repeats, then try again.', true);
        return;
      }
      string.querySelector('.kd-garland__gap').replaceWith(item(name, true));
      pulse(lio, 'is-nodding', 500);
      busy = true;
      if (round < ROUNDS.length - 1) {
        setHint(`Yes! A ${NAMES[name].toLowerCase()} comes next.`);
        window.setTimeout(() => { round += 1; busy = false; render(); }, reduceMotion ? 300 : 1100);
      } else {
        setHint('All three patterns done. Mission complete!');
        window.setTimeout(() => {
          busy = false;
          panel.classList.add('is-complete');
          speak(panel, panel.querySelector('[data-kd-say]').dataset.done);
          done.hidden = false;
          free = true;
          render();
          report(3);
        }, reduceMotion ? 300 : 1100);
      }
    };

    panel.querySelectorAll('[data-kd-choices] .kd-choice').forEach((button) => {
      button.addEventListener('click', () => choose(button.dataset.item, button));
    });
    panel.querySelector('[data-kd-clear]').addEventListener('click', () => { render(); setHint('Start again: any pattern you like.'); });
    panel.querySelector('[data-kd-replay]').addEventListener('click', () => {
      round = 0;
      free = false;
      panel.classList.remove('is-complete');
      done.hidden = true;
      speak(panel, story);
      setHint(hint.dataset.default);
      render();
      report(1);
      panel.querySelector('.kd-choice').focus();
    });
    render();
  }

  document.querySelectorAll('[data-kd-mission]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
    const beats = [...root.querySelectorAll('.kd-beat')];
    const progress = new Map(panels.map((panel) => [panel, panel.dataset.kdGame ? 1 : 0]));
    const showBeat = (n) => beats.forEach((beat, i) => {
      beat.classList.toggle('is-done', i + 1 < n || n === 3 && i === 2);
      beat.classList.toggle('is-current', i + 1 === n && n !== 3);
    });
    const active = () => panels.find((panel) => !panel.hidden);
    panels.forEach((panel) => {
      const report = (n) => {
        progress.set(panel, n === 1 ? 1 : Math.max(progress.get(panel), n));
        if (active() === panel) showBeat(progress.get(panel));
      };
      if (panel.dataset.kdGame === 'sort') sortGame(panel, report);
      if (panel.dataset.kdGame === 'garland') garlandGame(panel, report);
    });
    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
      showBeat(progress.get(panels[index]));
      if (focus) tabs[index].focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, false));
      tab.addEventListener('keydown', (event) => {
        const keys = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: tabs.length - 1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        select((keys[event.key] + tabs.length) % tabs.length, true);
      });
    });
  });
})();
